// contacts routes

const routes = [
  {
    path: "/contacts",
    name: "ContactsHome",
    component: () => import("@/views/contacts/ContactsHome.vue"),
    meta: { requiresAuth: true, app: "contacts" },
  },
  {
    path: "/contacts/credentials",
    name: "ContactsCredentials",
    component: () => import("@/views/contacts/CredentialsPage.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: "contacts" },
  },
];

export default routes;
